import { TLocalesKeys } from 'localization';

import { IHostGroupsResponse } from '../../Bookings/types';

export enum EType {
  APPLICATION = 'APPLICATION',
  WINDOW = 'WINDOW',
  CLICK = 'CLICK',
}

export interface IData extends Record<string, unknown> {
  title: string;
  numberLaunches: number;
  time: number;
  percent: number;
}

export interface ITableBlockProps {
  data: IData[];
  loading: boolean;
  apiCalled: boolean;
  type: EType;
}

export interface IChartBlockProps {
  type: EType;
  setType: (type: EType) => void;
  hostGroupsData?: IHostGroupsResponse;
  selectedHostGroup: number | null;
  setSelectedHostGroup: (value: number | null) => void;
  selectedHost: number | null;
  setSelectedHost: (value: number | null) => void;
}

export interface IError {
  title?: TLocalesKeys;
  message: TLocalesKeys;
}

export interface IPlayAndApplicationReportRequest {
  input: {
    from: string;
    to: string;
    type: 'APPLICATION' | 'WINDOW' | 'CLICK';
    hostGroupId?: number;
    hostId?: number;
  };
}

export interface IPlayAndApplicationReportResponse {
  applicationsReport: {
    labels: Array<string>;
    extraLabels: Array<string>;
    keys: Array<string>;
    points: number;
    data: Array<{ values: Array<number> }>;
    summary: Array<{ title: string; value: number }>;
  };
}

export interface IPlayAndApplicationReportFileResponse {
  applicationsReport: {
    url: string;
  };
}

export interface HostGroupsData {
  hostGroupsOverview: Array<{ id: number | string; title: string }>;
  hostsOverview: Array<{
    id: number | string;
    alias: string;
    group_id: number;
  }>;
}
